import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store/store";
import storage from "store";
import VueSweetalert2 from "vue-sweetalert2";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import vSelect from "vue-select";
import { loadDistributor } from "@/utils/distributor.helper";

Vue.component("v-select", vSelect);

Object.defineProperty(Vue.prototype, "$storage", { value: storage });
Vue.use(VueSweetalert2);
Vue.config.productionTip = false;
store.commit("initialiseStore");

const distrib = loadDistributor();
store.commit("setDistributor", distrib);

let vm = new Vue({
  store: store,
  router,
  render: (h) => h(App),
}).$mount("#app");
global.vm = vm;
